module.exports = __webpack_public_path__ + "img/sld_spare_2_t1_dark.8cc0facc.svg";